import { useEffect, useState } from "react";
import { PropTypes } from 'prop-types'

const useGeolocation = () => {
    const [geolocation, setGeolocation] = useState();
    const [error, setError] = useState()
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            function(position) {
              setGeolocation([position.coords.latitude,position.coords.longitude])
            },
            function(err) {
                setError(err)
            }
          );
    },[])

    return {geolocation, setGeolocation, error};
}
useGeolocation.propTypes = {
	geolocation: PropTypes.object,
    error: PropTypes.object
}
export default useGeolocation